<template>
  <div class="tabs__wrapper">
    <button :class="getActiveClass(1)" @click="() => setSelectTabs(1)">
      Все отзывы
    </button>
    <button
      class="item__position"
      :class="getActiveClass(2)"
      @click="() => setSelectTabs(2)"
    >
      Этот вариант ({{ count }})
    </button>
  </div>
</template>

<script lang="ts" setup>
const emit = defineEmits(['setTab']);
defineProps({
  count: {
    type: Number,
    default: 1,
  },
});
const selectTabs = ref(1);

const setSelectTabs = (tabs: number): void => {
  if (!tabs) return;
  selectTabs.value = tabs;
  emit('setTab', tabs);
};

const getActiveClass = (item: number) => {
  if (!item) return;
  if (item === selectTabs.value) {
    return 'tabs__item active';
  } else {
    if (item === 2) return 'tabs__item padding-left';
    if (item === 1) return 'tabs__item padding-right';
    return 'tabs__item';
  }
};

onMounted(() => {
  if (window?.curentReviewsTab) selectTabs.value = window.curentReviewsTab;
});
</script>
<style lang="scss" scoped>
.tabs__wrapper {
  position: relative;
  display: inline-block;
}

.tabs__item {
  background: $white;
  border: 1px solid $gray2;
  border-radius: 8px;
  padding: 4px 12px;
  font-family: 'Inter', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: $gray2;
  position: relative;
  cursor: pointer;
  transition: color 0.6s;
}

.active {
  border: 1px solid $main-cta;
  background: $main-cta;
  color: $white;
  z-index: 2;
}
.padding-left {
  padding-left: 20px;
}
.padding-right {
  padding-right: 20px;
}
.item__position {
  left: -10px;
}
</style>
